<script lang="ts" setup>
export type AwardsListItem = {
    title: string
    image: Image
}
export interface AwardsListProps {
    data: Array<AwardsListItem>
}

const props = defineProps<AwardsListProps>()
</script>

<template>
  <ul class="row gx-10 align-items-baseline">
    <AwardsListItem
      v-for="(award, index) in props.data"
      :key="`awards-list-item-${index}`"
      :award="award"
    />
  </ul>
</template>
